import {buscador,url} from "./mapListener";

var formData = new FormData();
formData.append("id",buscador.get("id"))

var seconds = 0;
var flag = false;

/**
    * Envia una solicitud para apartar una serie de asientos para el evento en cuestión.
    * @param table {number} Número de la mesa seleecionada
    * @param seats {number} Número de asientos solicitados
 * */

function eraseSelection(evt){
    var data = JSON.parse(localStorage.getItem("result"))

    formData.append("min",data.min)
    formData.append("max",data.max)

    fetch("https://savethechildrenmx.org/restoreSeats",{
        method:'POST',
        body:formData
    }).then(res=>{
        return res.text()
    }).then(txt=>{
        var data = JSON.parse(txt);
        if (data.status == 200){
            document.querySelector(".step-1").classList.remove("hide")
            document.querySelector(".step-2").classList.add("hide")
            document.getElementById("lugares").value=""
            document.querySelector(".step-1 button").classList.add("disabled")
            document.querySelector(".step-1 button").textContent="Ingresa un numero entre 1 y 10"
            document.querySelector(".step-1 button").setAttribute("disabled","disabled")
            document.getElementById("lugares").parentElement.classList.remove("is-valid")

            document.querySelectorAll(".mesa_container").forEach(element=>{
                element.classList.add("full")
            })
        }else{
            alert("Algo ha salido mal, recargaremos el sistema para solucionarlo.")
            window.location.reload()
        }
    })

}
export default async function savePlaces(table,seats){
    formData.append("table",table);
    formData.append("seats", seats);
    formData.append("evento",buscador.get("id"))

    if (buscador.get("owner") != null){
        formData.append("lockFilter",true)
    }

    await fetch(url+"/savePlaces",{
        method:'POST',
        body:formData
    }).then(resp=>{
        if (resp.status === 200){
            return resp.text()
        }
    }).then(txt=>{
        var data = JSON.parse(txt)
        localStorage.setItem("result", txt)
        var event_datas = new FormData();
        event_datas.append("event",buscador.get("id"))

        fetch("https://savethechildrenmx.org/getEventInformation",{
            method:'post',
            body: event_datas
        }).then(resp=>{
            return resp.text()
        }).then(txt=>{
            localStorage.setItem("prices",txt)


            var prices = JSON.parse(txt)
            prices = prices[0]

            flag = true;

            if (data.status === 200 || buscador.get("owner") != null) {
                document.querySelector(".table").textContent = data.table;

                var atras = document.createElement("button");
                atras.classList.add("erase")
                if (buscador.get("lang").localeCompare("en")==0){
                    atras.textContent = "Choose again"
                }else{
                    atras.textContent = "Volver a elegir"
                }
                atras.addEventListener('click',eraseSelection)

                document.querySelector(".table").appendChild(atras)

                document.querySelector(".seats").textContent = document.querySelector("#lugares").value;

                document.querySelector(".total").setAttribute("event_name",prices.nombre)
                if (buscador.get("lang").localeCompare("en")==0){
                    document.querySelector(".total").setAttribute("price",document.querySelector("#lugares").value*prices.usd)
                    document.querySelector(".total").setAttribute("currency","usd")
                    document.querySelector(".total").textContent = Intl.NumberFormat('es-MX',{style:"currency",currency:"USD"}).format(document.querySelector("#lugares").value * prices.usd);
                }else{
                    document.querySelector(".total").setAttribute("price",document.querySelector("#lugares").value*prices.mxn)
                    document.querySelector(".total").setAttribute("currency","mxn")
                    document.querySelector(".total").textContent = Intl.NumberFormat('es-MX',{style:"currency",currency:"MXN"}).format(document.querySelector("#lugares").value * prices.mxn) + " MXN";
                }


                document.querySelector(".step-1").classList.add("hide")
                document.querySelector(".step-2").classList.remove("hide")
                document.querySelector(".map-content").classList.add("custom-2")
                UpdateSeats();
            }else{
                console.log("Este lugar ya fue apartado por alguien mas")
            }
        })
    }).catch(error =>{
        console.log(error)
    })
}

function UpdateSeats(){
    seconds++;

    if (seconds === 5 || flag){
        seconds = 0;
        fetch(url+"/getEventSeats",{
            method: 'POST',
            body:formData
        }).then(resp=>{
            if (resp.status===200){
                return resp.text()
            }
        }).then(txt=>{
            var data = JSON.parse(txt)
            data.forEach(element=>{
                var content =document.querySelector(".mesa-"+ element.mesa);

                if (content) {
                    content = content.parentElement.querySelector(".silla-"+element.asiento)
                    setSeatColor(content, element.status)
                }
            })
        })
        flag = false;
    }
}

function setSeatColor(element, status){
    switch (status){
        case 'disponible':
            element.style.backgroundColor="#0FD521";
            break;
        case 'apartado':
            element.style.backgroundColor="#EFD516";
            break;
        case 'comprado':
            element.style.backgroundColor="#ff0000";
            break;
        case 'bloqueado':
            element.style.backgroundColor="#001f3f";
            break;
    }
}

export const start = function startUpdating(){
    setInterval(UpdateSeats,1000)
}


// WEBPACK FOOTER //
// ./src/plugins/Socket.js